export default __webpack_public_path__ + "static/media/Boiled Crawfish.6f4c8890.jpg";